/* globals localStorage */
import HTTP from './http.js';
import qs from 'qs';
import { SnackbarProgrammatic as Snackbar } from 'buefy';

export default {
  login(email, pass, cb) {
    cb = arguments[arguments.length - 1];
    if (localStorage.refresh_token) {
      if (cb) cb(true);
      this.onChange(true);
      return;
    }
    login_post(email, pass, res => {
      // console.log(res);
      if (res.authenticated) {
        localStorage.refresh_token = res.refresh_token;
        localStorage.access_token = res.access_token;
        Snackbar.open("You're logged in.");
        if (cb) cb(true);
        this.onChange(true);
      } else {
        Snackbar.open("Can't login to system.");
        if (cb) cb(false);
        this.onChange(false);
      }
    });
  },

  getToken() {
    return {
      refresh_token: localStorage.refresh_token,
      access_token: localStorage.access_token,
    };
  },
  setToken(access_token, refresh_token) {
    localStorage.refresh_token = refresh_token;
    localStorage.access_token = access_token;
    this.onChange(true);
  },
  logout(cb) {
    delete localStorage.refresh_token;
    delete localStorage.access_token;
    delete localStorage.user;
    delete localStorage.permissions;
    if (cb) cb();
    this.onChange(false);
  },

  loggedIn() {
    return !!localStorage.refresh_token;
  },

  onChange() {},
};

function login_post(email, pass, cb) {
  var config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

  HTTP.post('user/login', qs.stringify({ username: email, password: pass }), config)
    .then(response => {
      // console.log(response.data);
      // console.log("OK!");
      cb({
        authenticated: true,
        refresh_token: response.data.refresh_token,
        access_token: response.data.access_token,
      });
    })
    .catch(e => {
      cb({ authenticated: false });
    });
}



// WEBPACK FOOTER //
// ./src/libraries/auth.js